import { useState } from "react";
import styled from "styled-components";
import textFilter from "../../../../../helper/textFilter";
import { useSelector, useDispatch } from "react-redux";
import { handleActiveSelect } from "../../../../../features/layout/layoutSlice";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useEffect } from "react";
import { updateAracData } from "../../../../../features/addLoad/addLoadSlice";

const Container = styled.div`
  width: 500px;
  height: 40px;
  filter: none !important;
  background-color: ${({ theme }) => theme.mainBgColor};
  position: relative;

  input {
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    padding-right: 30px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
    border: 1px solid
      ${({ theme, isActive, isError }) =>
        isError
          ? "var(--color-red)"
          : isActive
          ? theme.mainTextColor
          : theme.mainBorderColor};
    border-radius: ${({ radius }) => radius};
    border-bottom-left-radius: ${({ isActive }) => isActive && 0};
    border-bottom-right-radius: ${({ isActive }) => isActive && 0};
    color: var(--color-dark);
    background-color: ${({ theme }) => theme.mainBgColor};

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
  }

  input:focus ~ label {
    color: ${({ theme }) => theme.mainTextColor};
    transform: translateY(-22px);
  }

  label {
    position: absolute;
    transform: ${({ value }) => value && "translateY(-22px)"};
    bottom: 12px;
    left: 20px;
    font-size: 12px;
    font-weight: var(--font-weight-lg);
    pointer-events: none;
    transition: all 0.3s ease;
    z-index: 5;
    color: ${({ theme, value }) =>
      value ? theme.mainTextColor : theme.secondaryTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
  }

  .arr-icon {
    position: absolute;
    right: 5px;
    top: 8px;
    transform: ${({ isActive }) => (isActive ? "rotate(90deg)" : "rotate(0)")};
    font-size: 1.6rem;
    transition: 0.3s;
  }

  .err-message {
    font-size: 12px;
    color: red;
  }

  .options {
    position: absolute;
    top: 40px;
    background-color: ${({ theme }) => theme.mainBgColor};
    display: flex;
    flex-direction: column;
    z-index: 10;
    width: 100%;
    border: 1px solid
      ${({ theme, isActive, isError }) =>
        isError
          ? "var(--color-red)"
          : isActive
          ? theme.mainTextColor
          : theme.mainBorderColor};
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .option {
      width: 100%;
      padding: 9px 20px;
      cursor: pointer;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-md);

      &:hover {
        background-color: ${({ theme }) => theme.secondaryBgColor};
      }
    }
  }
  .error{
    font-size: 10px;
    color: red;
    margin-top: 5px;
  }
  .disabled-input{
    border-color: ${({ theme }) => theme.mainBorderColor}
  }
`;

const KasaTuruInput = ({ data, name, labelText = "Kasa Tipi", isRequired }) => {
  const [text, setText] = useState(data?.kasaTypeName);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("")
  const [isDisabled, setIsDisabled] = useState(false)
  const kasaTipi = data?.aracTypeName

  const { activeSelect } = useSelector((state) => state.layout);
  const { showErrors, showRequiredPlaces } = useSelector(
    (state) => state.addLoad
  );
  const [isError, setIsError] = useState(false);
  const [options, setOptions] = useState([]);

  useEffect(() => {
      setText(data?.kasaTypeName);
  }, [data?.kasaTypeName]);

  useEffect(() => {
    setOptions(data?.kasaTypeOptions);
  }, [data?.kasaTypeOptions]);

  const handleChange = (e) => {
    const searchText = e.target.value;
    dispatch(handleActiveSelect(name));

    if (!searchText) {
      setOptions(data.kasaTypeOptions);
      // dispatch(handleActiveSelect(null))
    } else {
      const result = textFilter(data?.kasaTypeOptions, searchText, "name");
      setOptions(result);
    }

    setText(searchText);
  };

  const handleOptionClick = (item) => {
    dispatch(
      updateAracData({ kasaTypeName: item?.name, kasaTypeId: item?.id })
    );
    dispatch(handleActiveSelect(null))
  };

  useEffect(() => {
    //! bu submit esnasında boş girerse gösterilecek
    if (isRequired && !data?.kasaTypeName && showErrors) {
      return setIsError(true);
    }
    //! bu kullanıcı zorunlu alanları görüntülemek isterse
    if (isRequired && showRequiredPlaces) {
      return setIsError(true);
    } else {
      setIsError(false);
    }
  }, [isRequired, data?.kasaTypeName, showRequiredPlaces, showErrors]);

  // useEffect(() => {
  //   if (kasaTipi === '' && text !== '') {
  //     setErrorMessage('Kasa Tipi seçilmelidir.');
  //   } else {
  //     setErrorMessage('');
  //   }
  // }, [kasaTipi, text]);

  useEffect(() => {
    if (kasaTipi === '') {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }, [kasaTipi]);

  return (
    <Container
      value={text}
      radius={"5px"}
      isActive={activeSelect === name}
      isError={isError}
      onClick={(e)=>e.stopPropagation()}
    >
      <input
        type="text"
        id={"text"}
        onChange={handleChange}
        value={text}
        name={"text"}
        className={isDisabled && "disabled-input"}
        disabled={isDisabled}
        onClick={() =>
          dispatch(
            handleActiveSelect(
              activeSelect && activeSelect === name ? null : name
            )
          )
        }
        autoComplete="off"
      />
      <label htmlFor={"text"}>
        {labelText}
        {isRequired && " (Zorunlu)"}
      </label>
      <MdKeyboardArrowRight className="arr-icon" />
      {
        // activeSelect === name &&
        // <div className="err-message">
        //     {err}
        // </div>
      }
      {activeSelect === name && (
        <div className="options">
          {options?.map((item) => (
            <div
              key={item.id}
              className="option"
              onClick={() => handleOptionClick(item)}
            >
              {item?.name}
            </div>
          ))}
        </div>
      )}
      <p className="error">{errorMessage}</p>
    </Container>
  );
};

export default KasaTuruInput;
